// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsSessionSummary } from './InternalendpointsSessionSummary';
import {
  InternalendpointsSessionSummaryFromJSON,
  InternalendpointsSessionSummaryFromJSONTyped,
  InternalendpointsSessionSummaryToJSON,
  InternalendpointsSessionSummaryToJSONTyped,
} from './InternalendpointsSessionSummary';
import type { InternalendpointsSessionDetails } from './InternalendpointsSessionDetails';
import {
  InternalendpointsSessionDetailsFromJSON,
  InternalendpointsSessionDetailsFromJSONTyped,
  InternalendpointsSessionDetailsToJSON,
  InternalendpointsSessionDetailsToJSONTyped,
} from './InternalendpointsSessionDetails';

/**
 *
 * @export
 * @interface InternalendpointsGetSessionResponse
 */
export interface InternalendpointsGetSessionResponse {
  /**
   *
   * @type {InternalendpointsSessionDetails}
   * @memberof InternalendpointsGetSessionResponse
   */
  customResource?: InternalendpointsSessionDetails;
  /**
   *
   * @type {InternalendpointsSessionSummary}
   * @memberof InternalendpointsGetSessionResponse
   */
  summary?: InternalendpointsSessionSummary;
}

/**
 * Check if a given object implements the InternalendpointsGetSessionResponse interface.
 */
export function instanceOfInternalendpointsGetSessionResponse(
  value: object,
): value is InternalendpointsGetSessionResponse {
  return true;
}

export function InternalendpointsGetSessionResponseFromJSON(
  json: any,
): InternalendpointsGetSessionResponse {
  return InternalendpointsGetSessionResponseFromJSONTyped(json, false);
}

export function InternalendpointsGetSessionResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsGetSessionResponse {
  if (json == null) {
    return json;
  }
  return {
    customResource:
      json['customResource'] == null
        ? undefined
        : InternalendpointsSessionDetailsFromJSON(json['customResource']),
    summary:
      json['summary'] == null
        ? undefined
        : InternalendpointsSessionSummaryFromJSON(json['summary']),
  };
}

export function InternalendpointsGetSessionResponseToJSON(
  json: any,
): InternalendpointsGetSessionResponse {
  return InternalendpointsGetSessionResponseToJSONTyped(json, false);
}

export function InternalendpointsGetSessionResponseToJSONTyped(
  value?: InternalendpointsGetSessionResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customResource: InternalendpointsSessionDetailsToJSON(
      value['customResource'],
    ),
    summary: InternalendpointsSessionSummaryToJSON(value['summary']),
  };
}
